// ------------------------------------------------------------------------------------
//  stamps 2006
// ----------------------------------------------------------------------------------------
import img1a from "../assets/stamps 2006/106.jpg";
import img1b from "../assets/stamps 2006/206.jpg";
import img1c from "../assets/stamps 2006/306.jpg";
import img1d from "../assets/stamps 2006/406.jpg";
import img1e from "../assets/stamps 2006/506.jpg";
import img1f from "../assets/stamps 2006/706.jpg";
import img1g from "../assets/stamps 2006/906.jpg";

// -----------------------------------------------------
//  2007
// -----------------------------------------------------
import img1a1 from "../assets/stamps 2007/107.jpg";
import img1b1 from "../assets/stamps 2007/207.jpg";
import img1c1 from "../assets/stamps 2007/307.jpg";
import img1d1 from "../assets/stamps 2007/407.jpg";
import img1e1 from "../assets/stamps 2007/507.jpg";
import img1f1 from "../assets/stamps 2007/607.jpg";
import img1g1 from "../assets/stamps 2007/707.jpg";
import img1h1 from "../assets/stamps 2007/807.jpg";

// ---------------------------------------------------------
//  2008
// ---------------------------------------------------------
import img1a1a from "../assets/stamps 2008/108.jpg";
import img1d1a from "../assets/stamps 2008/308.jpg";
import img1e1a from "../assets/stamps 2008/408.jpg";
import img1f1a from "../assets/stamps 2008/508.gif";
import img1g1a from "../assets/stamps 2008/2081.jpg";
import img1h1a from "../assets/stamps 2008/2082.jpg";
// ---------------------------------------------------------
//  2009
// ---------------------------------------------------------
import img33 from "../assets/stamps 2009/109.jpg";
import img34 from "../assets/stamps 2009/209.jpg";
import img35 from "../assets/stamps 2009/309.jpg";
import img36 from "../assets/stamps 2009/409.jpg";
import img37 from "../assets/stamps 2009/509.jpg";
import img38 from "../assets/stamps 2009/609.jpg";
import img39 from "../assets/stamps 2009/709.jpg";
import img40 from "../assets/stamps 2009/809.jpg";
import img41 from "../assets/stamps 2009/909.jpg";
// import img42 from '../assets/stamps 2009/1009.jpg'
import img43 from "../assets/stamps 2009/1109.jpg";
import img44 from "../assets/stamps 2009/1209.jpg";
import img45 from "../assets/stamps 2009/1309.jpg";
import img46 from "../assets/stamps 2009/1409.jpg";
import img47 from "../assets/stamps 2009/1509.jpg";
import img48 from "../assets/stamps 2009/1609.jpg";
import img49 from "../assets/stamps 2009/12345.jpg";

// ==========================================
// ----------------2010----------------------
// ==========================================
import img50 from "../assets/stamps 2010/5 NOV 2010.jpg";
import img51 from "../assets/stamps 2010/20102.jpg";
import img52 from "../assets/stamps 2010/20103.jpg";
import img53 from "../assets/stamps 2010/20104.jpg";
import img54 from "../assets/stamps 2010/20105.jpg";
import img55 from "../assets/stamps 2010/20106.jpg";
import img56 from "../assets/stamps 2010/20107.jpg";
import img57 from "../assets/stamps 2010/20108.jpg";
import img58 from "../assets/stamps 2010/20109.jpg";
import img59 from "../assets/stamps 2010/201010.jpg";
import img60 from "../assets/stamps 2010/CDA2010Dec.jpg";
import img61 from "../assets/stamps 2010/MAIN2.jpg";
import img62 from "../assets/stamps 2010/SilverJubileeIIU2010_8.jpg";

// ------------------------------------------------------------
//  2011
// ============================================================
import img63 from "../assets/stamps 2011/2011-1.jpg";
import img64 from "../assets/stamps 2011/2011-2.jpg";
import img65 from "../assets/stamps 2011/13052011.jpg";
import img66 from "../assets/stamps 2011/13122011.jpg";
import img67 from "../assets/stamps 2011/16092011Space.jpg";
import img68 from "../assets/stamps 2011/21052011 (1).jpg";
import img69 from "../assets/stamps 2011/21052011.jpg";
import img70 from "../assets/stamps 2011/23092011Gymkhana.jpg";
import img71 from "../assets/stamps 2011/29082011.jpg";
import img72 from "../assets/stamps 2011/30112011.jpg";
import img73 from "../assets/stamps 2011/311220111.jpg";
import img74 from "../assets/stamps 2011/ChildArt24062011.jpg";
import img75 from "../assets/stamps 2011/fab18082011.jpg";
import img76 from "../assets/stamps 2011/HIV11062011.jpg";
import img77 from "../assets/stamps 2011/ICAP01072011.jpg";
import img78 from "../assets/stamps 2011/Russia11062011.jpg";
import img79 from "../assets/stamps 2011/smbs17072011.jpg";
import img80 from "../assets/stamps 2011/ZariBank14082011.jpg";

// -----------------------------------------------------
//  2012
// -----------------------------------------------------
import img95p from "../assets/stamps 2012/1stWindPower04012013.jpg";
import img93p from "../assets/stamps 2012/65YearsIndependence.jpg";
import img102p from "../assets/stamps 2012/01042012.jpg";
import img96p from "../assets/stamps 2012/05052012.jpg";
import img91p from "../assets/stamps 2012/16042012.jpg";
import img88p from "../assets/stamps 2012/18122012.jpg";
import img83p from "../assets/stamps 2012/19032012.jpg";
import img106p from "../assets/stamps 2012/22062012.jpg";
import img103p from "../assets/stamps 2012/ab18062012.jpg";
import img85p from "../assets/stamps 2012/ACollege.jpg";
import img105p from "../assets/stamps 2012/ArabianSea12102012.jpg";
import img90p from "../assets/stamps 2012/arfakarim.jpg";
import img89s from "../assets/stamps 2012/DepGeography26112012.jpg";
import img98p from "../assets/stamps 2012/fcabinet.jpg";
import img82pp from "../assets/stamps 2012/Gems.jpg";
import img104pp from "../assets/stamps 2012/HameedNaseem30102012.jpg";
import img99p from "../assets/stamps 2012/KingEdwardMedicalUniversity.jpg";
import img92p from "../assets/stamps 2012/MigratoryBirdsPakistan08092012.jpg";
import img97p from "../assets/stamps 2012/MLuthfullahKhan26112012.jpg";
import img94p from "../assets/stamps 2012/NIT26112012.jpg";
import img101p from "../assets/stamps 2012/NurKhan.jpg";
// import img102pp from '../assets/stamps 2012/Cpthalass30102012.jpg'
import img100p from "../assets/stamps 2012/SialkotChamber08092012.jpg";
import img87p from "../assets/stamps 2012/UNEP05062012.jpg";
import img81s from "../assets/stamps 2012/yaumeshuhada30102012.jpg";

// ========================================================================================
// stamps 2013
// ----------------------------------------------------------------------------------------

import gmi129 from "../assets/stamps 2013/AllamaMuhammadAsad.jpg";
import gmi131 from "../assets/stamps 2013/AllamaMuhammadIqbal.jpg";
import gmi132 from "../assets/stamps 2013/ECP_2013_Elections.jpg";
import gmi133 from "../assets/stamps 2013/EconomicCorperationOrganization(ECO).jpg";
import gmi134 from "../assets/stamps 2013/KinnairdCollege.jpg";
import gmi135 from "../assets/stamps 2013/PakArmyMuseum.jpg";
import gmi136 from "../assets/stamps 2013/Pakistan-Bible-Society.jpg";
import gmi137 from "../assets/stamps 2013/Perveen Shakir.jpg";
import gmi138 from "../assets/stamps 2013/QudratUllahShahab.jpg";
import gmi139 from "../assets/stamps 2013/SadiqMuhammadKhanAbbasi-v.jpg";
import gmi140 from "../assets/stamps 2013/ShafiqURRehman.jpg";
import gmi141 from "../assets/stamps 2013/SufiBarkatAli.jpg";
import gmi142 from "../assets/stamps 2013/SyedZamirJafri.jpg";
import gmi143 from "../assets/stamps 2013/nasirkazmi.jpg";

// ----------------------------------------------------------------------------------------
//  stamps 2014
// ----------------------------------------------------------------------------------------
import gmi1a from "../assets/stamps 2014/14th National Scout Jamboree-23rdDec-2014(Stamp).jpg";
import gmi2a from "../assets/stamps 2014/100-Years-of-Frontier-Constabulary-1.jpg";
import gmi3a from "../assets/stamps 2014/100-Years-of-Sahiwal-Breed-Conservation-1.jpg";
//import gmi4a from '../assets/stamps 2014/Forman-Christian-College-2.jpg'
import gmi5a from "../assets/stamps 2014/Golden_Jubilee_Pak_Navy_Submarin_Force_1.jpg";
import gmi6a from "../assets/stamps 2014/HabibJalib.jpg";
import gmi7a from "../assets/stamps 2014/HMHabib_The-Banker.jpg";
import gmi8a from "../assets/stamps 2014/International Anti Corruption Day December 9, 2014s.jpg";
import gmi9a from "../assets/stamps 2014/MMAlam-2.jpg";
import gmi10a from "../assets/stamps 2014/MONUMENTS OF ANCIENT CULTURES JOINT ISSUE PAKISTAN-UKRAINE-2014-12-25.jpg";
import gmi11a from "../assets/stamps 2014/On 100th Birthday Anniversary of Norman E. Borlaugs.jpg";
import gmi12a from "../assets/stamps 2014/Pakistan 2025 One Nation-One Vision.jpg";
import gmi13a from "../assets/stamps 2014/SINGLE STAMPS GEMS & MINERALS OF PAKISTAN DEC 11, 2014.jpg";

// ----------------------------------------------------------------------------------------
//  stamps 2015
// ----------------------------------------------------------------------------------------
import gmi1aa from "../assets/stamps 2015/100-Years-of-Urdu-University-in-Turkey-Stamp-2015-10-12.jpg";
import gmi2aa from "../assets/stamps 2015/2015-05-11-Stamp First 100MW Solar Plant.jpg";
// import gmi3aa from '../assets/stamps 2015/2015-09-17-On-the-eve-Defence-Day-Golden-Jubilee-Celeberations-Stamp.jpg.jpg'
import gmi4aa from "../assets/stamps 2015/2015-12-16-The-First-Anniversary-of-The-Gruesome-Incident-of-the-Army-Publick-School-Peshawar--Stamp.jpg";
import gmi5aa from "../assets/stamps 2015/China-Friendly-Commemorative-August14-2015.jpg";
import gmi6aa from "../assets/stamps 2015/Muree-GPO-29thDec2015-stamp.jpg";
import gmi7aa from "../assets/stamps 2015/On-Restoration-of-Murree-GPO-2015-11-04-stmp.jpg";

// ---------------------------------------------------------
//  2016
// ----------------------------------------------------------

import img107 from "../assets/stamps 2016/2016-02-10-On-Completion-of-50-Years-of-Safe-Operation-of-1st-NUCLEAR- RE-SEARCH- REACTOR-in-Pak-stamp.jpg";
import img108 from "../assets/stamps 2016/2016-08-17-Abdul-Sattar-Edhi-Philanthropist-1926-2016-Stamp.jpg";
import img109 from "../assets/stamps 2016/2021-10-16-Stamps-Pakistan-And-Belarus-Joint-Issue-Commemorative-Postage-Stamps-October-05-2016.jpg";
import img110 from "../assets/stamps 2016/2021-10-16-Stamps-Platinum-Jubilee-Habib-Bank-Limited-1941-2016-Commemorative-Postage-Stamps-September-23-2016.jpg";
import img111 from "../assets/stamps 2016/2021-10-18-Stamps-50-Years-Of-Establishment-Diplomatic-Relations-Pakistan-and-Singapore-Joint-Issue-Commemorative-Postage-Stamps-October-18-2016.jpg";
import img112 from "../assets/stamps 2016/2021-10-18-Stamps-100-Years-Celebration-Of-The-Rotary-Foundation-Commemorative-Postage-Stamps-November-20-2016.jpg";
import img113 from "../assets/stamps 2016/2021-12-04-Stamp-Celebrations-Of-National-Voters-Day- Election-Commission-Of-Pakistan-Commemorative-Postage-Stamp-December-7-2016.jpg";
import img114 from "../assets/stamps 2016/2021-12-04-Stamp-Child-Art-Competition-Stamps-National-Stamp-Exhibition-Pakistan-2016-Karachi-Special-Postage-Stamps-December-30-2016.jpg";
import img115 from "../assets/stamps 2016/2021-12-04-Stamp-Dinshaw-Byramji-Avari-Philanthropist-1902-1988-Commemorative-Postage-Stamp-December-18-2016.jpg";
import img116 from "../assets/stamps 2016/2021-12-04-Stamp-Sesquicentennial-Celebrations-Lahore High-Court-Commemorative-Postage-Stamp-November-26-2016.jpg";
import img117 from "../assets/stamps 2016/stamp-2016-03-22.jpg";
import img118 from "../assets/stamps 2016/Stamp-2016-03-National Book Day-2016-04-22.jpg";
import img119 from "../assets/stamps 2016/Stamp-2016-05-65th-Anniversary-of-Diplomatic-Relations-Pak-&-China-2016-05-25.jpg";
import img200 from "../assets/stamps 2016/Stamp-2016-07-On-Centenary-of-The-DGTR-House-Building-Karachi-Stamp-2016-09-06.jpg";
import img201 from "../assets/stamps 2016/Stamp-No-2016-04-(26thApril2016).jpg";

// -----------------------------------------------------------------
//                         1900
// -----------------------------------------------------------------

import img1 from "../assets/stamps/AllamaMuhammadIqbal.jpg";
import img2 from "../assets/stamps/2016-08-17-Abdul-Sattar-Edhi-Philanthropist-1926-2016-Stamp.jpg";
import img3 from "../assets/stamps/HabibJalib.jpg";
import img4 from "../assets/stamps/100-Years-of-Urdu-University-in-Turkey-Stamp-2015-10-12.jpg";
import img5 from "../assets/stamps/2015-05-11-Stamp First 100MW Solar Plant.jpg";
import img6 from "../assets/stamps/2015-09-17-On-the-eve-Defence-Day-Golden-Jubilee-Celeberations-Stamp.jpg";
// import img7 from '../assets/stamps/2016-02-10-On-Completion-of-50-Years-of-Safe-Operation-of-1st-NUCLEAR- RE-SEARCH- REACTOR-in-Pak-stamp.jpg'
import img8 from "../assets/stamps/MMAlam-2.jpg";
import img9 from "../assets/stamps/Stamp-2016-07-On-Centenary-of-The-DGTR-House-Building-Karachi-Stamp-2016-09-06.jpg";
// import img10 from '../assets/stamps/Stamp-No-2016-04-26thApril2016.jpg'

// ---------------------------------------------------------
//  2017
// ----------------------------------------------------------

import img202 from "../assets/stamps 2017/2017-01-06-Stamp-international-year-of-sustainable-tourism-for-development-2017a.jpg";
import img203 from "../assets/stamps 2017/2017-03-07-Stamp-13th-Economic-Cooperation-Organization-Summit-at-Islamabad-Commemorative-Postage-Stamps-March-01-2017-1.jpg";
import img204 from "../assets/stamps 2017/2017-03-07-Stamp-13th-Economic-Cooperation-Organization-Summit-at-Islamabad-Commemorative-Postage-Stamps-March-01-2017.jpg";
import img205 from "../assets/stamps 2017/2017-07-06-Stamp-Men-Of-Letters-Series-Majeed-Amjad-Commemorative-Postage-Stamps-June-29-2017-Stamp.jpg";
import img206 from "../assets/stamps 2017/2017-07-11-Stamp-Pakistan-And-Asian-Development-Bank-50-Years-Of-Partinering-For-Development-Commemorative-Postage-Stamps-July-06-2017.jpg";
import img207 from "../assets/stamps 2017/2017-10-20-Stamp-Maulana-Mufti-Mahmood-1919-1980-Commemorative-Postage-Stamps-October-14-2017.jpg";
import img208 from "../assets/stamps 2017/2017-10-20-Stamp-On-The-Occasion-of-200th-Anniversary-Sir-Syed-Ahmed-Khan-For-Commemorative-Postage-Stamps-and-Souvenir-Sheet-October-17-2017.jpg";
import img209 from "../assets/stamps 2017/2017-11-07-Stamp-70th-Anniversary-of-Establishment-of-Diplomatic-Relations-Between-Pakistan-and-Turkey-Souvenir-Sheet-November-09-2017.jpg";
import img210 from "../assets/stamps 2017/2017-11-07-Stamp-On-125th-Anniversary-of-Goverment-Islamia-College-Railway-road-Lahore-Commemorative-Postage-Stamp-November-01-2017.jpg";
import img211 from "../assets/stamps 2017/2017-11-07-Stamp-The-Champions-ICC-Champions-Trophy-2017-Commemorative-Postage-Stamp-November-02-2017.jpg";
import img212 from "../assets/stamps 2017/2017-12-06-Stamp-Dr-Ruth-Katharina-Martha-PFAU-1929-2017-Commemorative-Postage-Stamp-December-03-2017.jpg";
import img213 from "../assets/stamps 2017/2017-12-06-Stamp-On-75th-Anniversary-of-No.-6-Air-Transport-Support-Squadron-Pakistan-Air-Force-Commemorative-Postage-Stamp-December-01-2017.jpg";
import img214 from "../assets/stamps 2017/2017-12-21-Stamps-His-Highness-The-Aga-Khan-1957-Diamond-Jubilee-2017-Commemorative-Postage-Stamps-December-08-2017.jpg";

// ---------------------------------------------------------
//  2018
// ----------------------------------------------------------

import img215 from "../assets/stamps 2018/2018-06-23-Stamp-60th- Anniversary-of-Urdu-Dictionary-Board-Commemorative-Postage-Stamps-June-14-2018.jpg";
import img216 from "../assets/stamps 2018/2018-07-03-Stamps-18-th-Meeting-of-the-Council-Of-Heads-Of-State-Of-Shanghai-Cooperation-Organization-Qingdao-Summit-2018-Commemorative-Postage-Stamps-June-09-2018.jpg";
import img217 from "../assets/stamps 2018/2018-07-03-Stamps-70-Years-Of-Excellence-State-Bank-Of-Pakistan-1948-2018-Commemorative-Postage-Stamps-July-01-2018.jpg";
import img218 from "../assets/stamps 2018/2018-07-26-Stamp-100-Years-of-Mama-Parsi-Girls-Secondary-School-Karachi-1918-2018-Commemorative-Postage-Stamps-July-24-2018.jpg";
import img219 from "../assets/stamps 2018/2018-09-24-Stamp-Kashmir-Martyrs- Day-Atrocities-in-IOK-Commemorative-Postage-Stamps-July-13-2018.jpg";
import img220 from "../assets/stamps 2018/2018-12-04-Stamp-Jamsheed- Marker-Ex-Amassador-Born-November-24-1922-Quetta-Died-June-21-2018-Karachi-Commemorative-Postage-Stamps-November-24-2018.jpg";
import img221 from "../assets/stamps 2018/2018-12-04-Stamp-On-the-10th-Edition-of-International-Defence-Exhibition-and-Seminar-Ideas-2018-Defence-Export-Promotion-Organization-Commemorative-Postage-Stamps-November-27-2018.jpg";
import img222 from "../assets/stamps 2018/2018-12-12-Stamp-International-Anticorruption-day-carrying-message-united-agaisnt-corruption-for-prosperous-Pakistan-Commemorative-Postage-Stamps-December-09-2018.jpg";
import img223 from "../assets/stamps 2018/2019-01-11-Stamp-50-Years-Of-Crescent-Model-Higher-Secondary-School-Lahore-1968-2018-Commemorative-Postage-Stamps-December-26-2018.jpg";
import img224 from "../assets/stamps 2018/2019-01-11-Stamp-Silver-Jubilee-Ghulam-Ishaq-Khan-Institute-Of-Engineering-Sciences-and-Technology-1993-2018-Commemorative-Postage-Stamps-December-24-2018.jpg";
import img225 from "../assets/stamps 2018/stamps 05-03-2018.jpg";
import img226 from "../assets/stamps 2018/stamps 08-06-2018.jpg";
import img227 from "../assets/stamps 2018/stamps-09-02-2018-a.jpg";
import img228 from "../assets/stamps 2018/stamps-09-02-2018-b.jpg";
import img229 from "../assets/stamps 2018/stamps-09-02-2018-c.jpg";

// ----------------------------------------------------------------------------------------
//  stamps 2019
// ----------------------------------------------------------------------------------------
import img1bz from "../assets/stamps 2019/2019-03-04-Stamps-Death-Anniversary-of-Mirza-Asadullah-Khan-Ghalib-2019-Commemorative-Postage-Stamps-February-15-2019.jpg";
import img2bz from "../assets/stamps 2019/2019-07-11-Stamp-Pakistans-First-Remote-Sensing-Satellites-Commemorative-Postage-Stamps-July-09-2019.jpg";
import img3bz from "../assets/stamps 2019/2019-08-24-Stamp-Silver-Jubilee-Ghulam-Ishaq-Khan-Institute-Of-Engineering-Sciences-and-Technology-1993-2018-Commemorative-Postage-Stamps-December-24-2018.jpg";
import img4bz from "../assets/stamps 2019/2019-10-09-Stamps-Commission-On-Science-And-Technology-For-Sustainable-Development-In-The-South-Comsats-Commemorative-Postage-Stamps-October-4-2019.jpg";
// import img5bz from '../assets/stamps/2019-11-02-Stamps-Japans-International-Cooperation-Towards-Pakistan-Commemorative-Postage-Stamps-October-22-2019.jpg'
// import img6bz from '../assets/stamps/2019-11-04-Stamps-30th-Years-Of-The-Convention-On-The-Rights-Of-The-Child-CRC-Commemorative-Postage-Stamps-November-04-2019.jpg'
// import img7bz from '../assets/stamps/2019-11-18-Stamps-550th-Birthday-Celebrations-of-Sri-Guru-Nanak-Dev-Ji-1469-2019-Commemorative-Postage-Stamps-November-12-2019.jpg'
// import img8bz from '../assets/stamps/2020-01-02-Stamps-Golden-Jubilee-Celebrations-of-OIC-1969-2019-Commemorative-Postage-Stamp-and-Sovunier-Sheet-December-30-2019.jpg'

// ----------------------------------------------------------------------------------------
//  stamps 2020
// ----------------------------------------------------------------------------------------
import img1bb from "../assets/stamps 2020/2020-01-15-Stamps-100th-Birthday-Of-Shaheed-Hakim-Mohammed-Said-1920-2020-Commemorative-Postage-Stamp-January-10-2020.jpg";
import img2bb from "../assets/stamps 2020/2020-02-17-Stamps-Kashmir-Solidarity-Day-Commemorative-Postage-Stamp-February-05-2020.jpg";
import img3bb from "../assets/stamps 2020/2020-02-24-Details-High-Level.jpg";
import img4bb from "../assets/stamps 2020/2020-02-24-Stamp-Mahmud-Ali.jpg";
import img5bb from "../assets/stamps 2020/2020-07-03-Stamps-International-Day-Against-Drug-Abuse-and-Illicit-Trafficking-Say-No-To-Drugs-Commemorative-Postage-Stamp-June-26-2020.jpg";
import img6bb from "../assets/stamps 2020/2020-07-13-Stamps-World-Population-Day-2020-Commemorative-Postage-Stamp-July-11-2020.jpg";
import img7bb from "../assets/stamps 2020/2020-08-07-Stamp-One-Year-of-Indian-Occupied-Jammu-and-Kashmir-under-Siege-Special-Postage-Stamp-August-05-2020.jpg";
import img8bb from "../assets/stamps 2020/2020-08-07-Stamp-Silver-Jubilee-of-Shaukat-Khanum-Memorial-Cancer-Hospital-and-Research-Centre-Lahore-Commemorative-Postage-Stamp-August-06-2020.jpg";
import img9bb from "../assets/stamps 2020/2020-09-14-Stamp-Services-To-The-Cause-Of-Creation-Of-Pakistan-Of-Miangul-Abdul-Haq-Jahanzeb-Former-Wali-Of-Swat-State-Commemorative-Postage-Stamp-September-14-2020.jpg";
import img10bb from "../assets/stamps 2020/2020-10-27-Stamp-75th-Anniversary-Of-United-Nations-Commemorative-Postage-Stamp-October-24-2020.jpg";
import img11bb from "../assets/stamps 2020/2020-11-12-Stamp-Pink-Ribbon-Breast-Cancer-Awareness-Special-Postage-Stamp-November-11-2020.jpg";
import img12bb from "../assets/stamps 2020/2020-12-29-Stamp-New-Political-Map-Of-Pakistan-2020-Special-Postage-Stamp-December-25-2020.jpg";
// ---------------------------------------------------------
//  2021
// ----------------------------------------------------------

import img92 from "../assets/stamps 2021/2021-03-31-Stamp-10-Years-Of-Karnal-Sher-Khan-Cadit-College-Swabi-2011-2021-Commemorative-Postage-Stamp-April-4-2021.jpg";
import img93 from "../assets/stamps 2021/2021-05-25-Stamp-17th-Anniversary-of-Diplomatic-Relations-Between-Pakistan-and-China-Commemorative-Postage-Stamp-May-21-2021.jpg";
import img94 from "../assets/stamps 2021/2021-06-09-Stamp-World-Environment-Day-Pakistan-2021-Commemorative-Postage-Stamp-June-05-2021.jpg";
import img95 from "../assets/stamps 2021/2021-06-24-Stamp-100th-Anniversary-of-Insulin-Discovery-1921-2021-Commemorative-Postage-Stamp-June-24-2021.jpg";
import img96 from "../assets/stamps 2021/2021-07-06-Stamp-State-Bank-of-Pakistan-Museum-A-Decade-of-Serving-Heritage-2011-2021-Commemorative-Postage-Stamp-July-1-2021.jpg";
import img97 from "../assets/stamps 2021/2021-08-03-Stamp-100-Years-Of-Excellence-NED-University-Karachi.jpg";
import img98 from "../assets/stamps 2021/2021-09-27-Stamps-National-Newspapers-Readership-Day-Commemorative-Postage-Stamps-September-25-2021.jpg";
import img99 from "../assets/stamps 2021/2021-10-07-Stamps-On-Pakistan-Telecommunication-Authority-Commemorative-Postage-Stamps-September-30-2021.jpg";
import img100 from "../assets/stamps 2021/2021-10-07-Stamps-On-The-Eve-Of-Karachi-Nuclear-Power-Plant-Inauguration-Unit-2-K-2-Commemorative-Postage-Stamps-September-30-2021.jpg";
import img101 from "../assets/stamps 2021/2021-11-03-Stamps-Completion-Of-100-Years-Establishment-Of-University-Of-Engineering-And-Technology-Lahore-1921-2021-Commemorative-Postage-Stamps-November-1-2021.jpg";
import img102 from "../assets/stamps 2021/2021-11-09-Stamp-70-Years-of-Diplomatic-Relations-Between-Pakistan-and-Germany-1951-2021-Commemorative-Postage-Stamps-November-9-2021.jpg";
// import img103 from '../assets/stamps 2022/2021-12-21-Stamp-Golden-Jubilee-of-Hangor-Day-Commemorative-Postage-Stamp-December-09-2021.jpg'
// import img104 from '../assets/stamps 2022/2021-12-31-Detail-70th-Anniversary-of-Est-of-Diplomatic-rlt-bet-Pak-thailand-Commemorative-Postage-Stamp-December-31-2021.jpg'

// ---------------------------------------------------------
//  2022
// ----------------------------------------------------------

import img81 from "../assets/stamps 2022/2022-01-12-Stamp-70th-Anniversary-of-Est-of-Diplomatic-rlt-bet-Pak-Japan-Commemorative-Postage-Stamp-January-01-2022.jpg";
import img82 from "../assets/stamps 2022/2022-06-01-Stamp-48th-Session-of-OIC-Councile-of-Foreign-Ministers-Commemorative-Postage-Stamp-March-23-2022.jpg";
import img83 from "../assets/stamps 2022/2022-06-01-Stamp-100-Glorious-Years-of-Lahore-College-For-Women-Unverisity-Commemorative-Postage-Stamp-May-25-2022.jpg";
import img84 from "../assets/stamps 2022/2022-06-27-Stamp-The-70th-Anniversiary-Of-Pakistan-and-Span-Commemorative-Postage-Stamp-January-14-2022.jpg";
import img85 from "../assets/stamps 2022/2022-07-28-Stamp-Centennial-Celebrations-Of-Attock-Refinery-Limited-Commemorative-Postage-Stamp-July-25-2022.jpg";
import img86 from "../assets/stamps 2022/2022-08-15-Stamp-Diamond-Jubilee-Of-Pakistan-1947-2022-Commemorative-Postage-Stamp-August-14-2022.jpg";
import img87 from "../assets/stamps 2022/2022-08-16-Stamp-On-The-11th-Edition-of-Int-Def-Exhi-And-Seminar-Ideas-2022-Commemorative-Postage-Stamp-August-14-2022.jpg";
import img88 from "../assets/stamps 2022/2022-11-14-Stamp-On-The-Occasion-of-75th-Anniversary-of-Pak-Inst-of-Inter-Aff-Commemorative-Postage-Stamp-November-14-2022.jpg";
import img89 from "../assets/stamps 2022/2022-11-16-Stamp-75-Years-Deplomatic-Relation-Between-Pakistan-and-Australia-Commemorative-Postage-Stamp-November-15-2022.jpg";
import img90 from "../assets/stamps 2022/2022-11-24-Stamp-Celebrate-100-Years-of-IDA-for-Service-Schools-for-Blind-Deaf-Children-Commemorative-Postage-Stamp-November-23-2022.jpg";
import img91 from "../assets/stamps 2022/2022-12-30-Stamp-75th-Anniversary-of-Diplomatic-rlt-bet-Pak-and-usa-commemorative-Postage-Stamp-December-27th-2022.jpg";

// ------------------------------------------------------------------------------------------
// stamps 2023
// ------------------------------------------------------------------------------------------

import img2023q from "../assets/stamps 2023/2023-01-25-Stamp-40-Years-of-Wafaqi-Mohtasib-Ombudsman-Islamabad-1983-2023-Commemorative-Postage-Stamp-January-24-2023.jpg";
import img2023r from "../assets/stamps 2023/2023-03-09-Stamp-International-Women-Day-Commemorative-Postage-Stamp-March-8-2023.jpg";
import img2023s from "../assets/stamps 2023/2023-03-15-Stamp-Golden-Jubilee-Celebrations-of-the-Senate-of-Pakistan-Commemorative-Postage-Stamp-March-15-2023.jpg";
import img2023t from "../assets/stamps 2023/2023-04-10-Stamp-Golden-Jublee-Celebrations-Commemorative-Postage-Stamp-April-10-2023.jpg";
import img2023u from "../assets/stamps 2023/2023-05-20-Stamp-Golden-Jubilee-Celebrations-of-NESPAK-Commemorative-Postage-Stamp-May-10-2023.jpg";
import img2023v from "../assets/stamps 2023/2023-05-24-Stamp-Golden-Jubilee-Celebrations-of-PMC-FSD-1973-2023-Commemorative-Postage-Stamp-May-16-2023.jpg";
import img2023w from "../assets/stamps 2023/2023-05-29-Stamp-25-Years-of-Excellence-of-Central-Depository-Company-of-Pak-Ltd-Commemorative-Postage-Stamp-May-23-2023.jpg";
import img2023x from "../assets/stamps 2023/2023-05-31-Stamp-7th-Population-and-Housing-Census-First-Ever-Digital-Census-in-Pak-Commemorative-Postage-Stamp-May-23-2023.jpg";
import img2023y from "../assets/stamps 2023/2023-08-09-Stamp-Decade-of-China-Pak-Economic-Corridor-Commemorative-Postage-Stamp-5-7-2023.jpg";
import img2023z from "../assets/stamps 2023/2023-08-09-Stamp-Raja-M-Sarwar-Shaheed-Commemorative-Postage-Stamp-27-07-2023.jpg";

export const AllButtons = [
  {
    year: "2006",
    id: "2006",
  },

  {
    year: "2007",
    id: "2007",
  },

  {
    year: "2008",
    id: "2008",
  },

  {
    year: "2009",
    id: "2009",
  },

  {
    year: "2010",
    id: "2010",
  },

  {
    year: "2011",
    id: "2011",
  },

  {
    year: "2012",
    id: "2012",
  },

  {
    year: "2013",
    id: "2013",
  },

  {
    year: "2014",
    id: "2014",
  },

  {
    year: "2015",
    id: "2015",
  },

  {
    year: "2016",
    id: "2016",
  },

  {
    year: "2017",
    id: "2017",
  },

  {
    year: "2018",
    id: "2018",
  },

  {
    year: "2019",
    id: "2019",
  },

  {
    year: "2020",
    id: "2020",
  },

  {
    year: "2021",
    id: "2021",
  },

  {
    year: "2022",
    id: "2022",
  },
  {
    year: "2023",
    id: "2023",
  },
];

export const Buttona = [
  // 1900

  {
    id: 1,
    heading: "Stamp: 2023-01",
    year: "1900",
    paragraph: "this is my website content",
    image: img1,
  },
  {
    id: 2,
    heading: "heading 2",
    year: "1900",
    paragraph: "paragraph 2",
    image: img2,
  },
  {
    id: 3,
    heading: "heading 3",
    year: "1900",
    paragraph: "paragraph 3",
    image: img3,
  },
  {
    id: 4,
    heading: "heading 4",
    year: "1900",
    paragraph: "paragraph 4",
    image: img4,
  },
  {
    id: 5,
    heading: "heading 5",
    year: "1900",
    paragraph: "paragraph 5",
    image: img5,
  },
  {
    id: 6,
    heading: "heading 6",
    year: "1900",
    paragraph: "paragraph 6",
    image: img6,
  },
  // {
  //     id: 7,
  //     heading: 'heading 1',
  //     year:'1900',
  //     paragraph: 'paragraph 1',
  //     image: img7,
  // },
  {
    id: 8,
    heading: "heading 8",
    year: "1900",
    paragraph: "paragraph 8",
    image: img8,
  },
  {
    id: 9,
    heading: "heading 9",
    year: "1900",
    paragraph: "paragraph 9",
    image: img9,
  },
  // {
  //     id: 10,
  //     heading: 'heading 1',
  //     year:'1900',
  //     paragraph: 'paragraph 1',
  //     image: img10,
  // },
  // {
  //     id: 11,
  //     heading: 'heading 11',
  //     year: '1900',
  //     paragraph: 'paragraph 11',
  //     image: img11,
  // },
];

// ----------------------------------------------------------
// 2006
// ----------------------------------------------------------

export const Buttonb = [
  {
    id: 12,
    heading: "13 March 2006",
    year: "2006",
    paragraph: "Centenary of birth of Begum Ra'na Liaquat Ali Khan (1905-1990)",
    image: img1a,
  },
  {
    id: 13,
    heading: "23 March 2006",
    year: "2006",
    paragraph: "Justice for All - Golden Jubilee of Supreme Court of Pakistan",
    image: img1b,
  },
  {
    id: 14,
    heading: "23 March 2006",
    year: "2006",
    paragraph: "Justice for All - Golden Jubilee of Supreme Court of Pakistan",
    image: img1c,
  },
  {
    id: 15,
    heading: "14 April 2006",
    year: "2006",
    paragraph:
      "Quaid-i-Azam Muhammad Ali Jinnah's Visit to Armoured Corps Centre",
    image: img1d,
  },
  {
    id: 16,
    heading: "14 April 2006",
    year: "2006",
    paragraph:
      "Quaid-i-Azam Muhammad Ali Jinnah's Visit to Armoured Corps Centre",
    image: img1e,
  },
  {
    id: 17,
    heading: "1 July 2006",
    year: "2006",
    paragraph: "Shandur Polo Festival",
    image: img1f,
  },
  {
    id: 18,
    heading: "20 July 2006",
    year: "2006",
    paragraph: "Promotion of Tourism in Pakistan - Lake Payee",
    image: img1g,
  },
];
// ------------------------------------------------------------
// 2007
// ------------------------------------------------------------
export const Buttonc = [
  {
    id: 19,
    heading: "16 January 2007",
    year: "2007",
    paragraph: "Platinum Jubilee Celebration of K.M.C. Building Karachi",
    image: img1a1,
  },
  {
    id: 20,
    heading: "28 February 2007",
    year: "2007",
    paragraph: "Golden Jubilee of Cadet College Petaro",
    image: img1b1,
  },
  {
    id: 21,
    heading: "08 March 2007",
    year: "2007",
    paragraph: "International Women's Day",
    image: img1c1,
  },
  {
    id: 22,
    heading: "26 May 2007",
    year: "2007",
    paragraph: "Mr. Hugh Catchpole",
    image: img1d1,
  },
  {
    id: 23,
    heading: "07 June 2007",
    year: "2007",
    paragraph: "New Vision of Pakistan Post",
    image: img1e1,
  },
  {
    id: 24,
    heading: "6 September 2007",
    year: "2007",
    paragraph: "Pakistan Air Force Defence Day",
    image: img1f1,
  },
  {
    id: 25,
    heading: "15 November 2007",
    year: "2007",
    paragraph: "Completion of Five Years Term of National Assembly of Pakistan",
    image: img1g1,
  },
  {
    id: 26,
    heading: "19 November 2007",
    year: "2007",
    paragraph: "Centenary Celebration of Catholic Cathedral Church Lahore",
    image: img1h1,
  },
];
// -------------------------------------------------------------
//   2008
// -------------------------------------------------------------

export const Buttond = [
  {
    id: 27,
    heading: "4 April 2008",
    year: "2008",
    paragraph: "29th Martyrdom Anniversary Shaheed Zulfikar Ali Bhutto",
    image: img1a1a,
  },
  {
    id: 28,
    heading: "08 October 2008",
    year: "2008",
    paragraph: "3rd Anniversary of Earthquake",
    image: img1d1a,
  },
  {
    id: 29,
    heading: "10 December 2008",
    year: "2008",
    paragraph: "United Nations Human Rights Award 2008 For Mohtarma Benazir Bhutto",
    image: img1e1a,
  },
  {
    id: 30,
    heading: "27 December 2008",
    year: "2008",
    paragraph: "1st Martyrdom Anniversary of Mohtarma Benazir Bhutto Shaheed",
    image: img1f1a,
  },
  {
    id: 31,
    heading: "21 June 2008",
    year: "2008",
    paragraph: "55th Birthday Celebrations of Mohtarma Benazir Bhutto (Shaheed)",
    image: img1g1a,
  },
  {
    id: 32,
    heading: "21 June 2008",
    year: "2008",
    paragraph: "55th Birthday Celebrations of Mohtarma Benazir Bhutto (Shaheed)",
    image: img1h1a,
  },
];

// ===================================================================
//                         2009
// ===================================================================

export const Buttone = [
  {
    id: 33,
    heading: "11 March 2009",
    year: "2009",
    paragraph: "10th ECO Summit at Tehran Iran Commemorative Postage Stamp",
    image: img33,
  },
  {
    id: 34,
    heading: "23 March 2009",
    year: "2009",
    paragraph:
      "National Year of Environment 2009 - Deodar Commemorative Postage Stamp",
    image: img34,
  },
  {
    id: 35,
    heading: "23 March 2009",
    year: "2009",
    paragraph:
      "National Year of Environment 2009 - Chukar Commemorative Postage Stamp",
    image: img35,
  },
  {
    id: 36,
    heading: "23 March 2009",
    year: "2009",
    paragraph: "National Year of Environment 2009 - Jasmine",
    image: img36,
  },
  {
    id: 37,
    heading: "23 March 2009",
    year: "2009",
    paragraph: "National Year of Environment 2009 - Markhor",
    image: img37,
  },
  {
    id: 38,
    heading: "29 March 2009",
    year: "2009",
    paragraph: "Golden Jubilee of Habib Public School Karachi",
    image: img38,
  },
  {
    id: 39,
    heading: "23 May 2009",
    year: "2009",
    paragraph:
      "On the eve of Completion 150 Years of Bai Virbaiji Sparivala Parsi High School Karachi (1859-2009)",
    image: img39,
  },
  {
    id: 40,
    heading: "30 May 2009",
    year: "2009",
    paragraph:
      "75th Anniversary of The Karachi Chamber of Commerce & Industry (KCCI) Building (1934-2009)",
    image: img40,
  },
  {
    id: 41,
    heading: "10 July 2009",
    year: "2009",
    paragraph: "3rd Death Anniversary of Ahmad Nadeen Qasmi",
    image: img49,
  },
  {
    id: 42,
    heading: "1 August 2009",
    year: "2009",
    paragraph:
      "CONTRIBUTING SALE PROCEEDS TO THE PRIME MINISTERS RELIEF FUND FOR SWAT REFUGEES (SPECIAL POSTAGE STAMPS SHEET)",
    image: img41,
  },
  {
    id: 43,
    heading: "11 August 2009",
    year: "2009",
    paragraph: "Celebration of Minorities Week 5th to 11th August, 2009",
    image: img43,
  },
  {
    id: 44,
    heading: "14 August 2009",
    year: "2009",
    paragraph: "Independence Day",
    image: img44,
  },
  {
    id: 45,
    heading: "15 August 2009",
    year: "2009",
    paragraph: "Urs of Abul Hassan Muhammad Jamal-ud-Din Musa Paak Shaheed",
    image: img45,
  },
  {
    id: 46,
    heading: "16 August 2009",
    year: "2009",
    paragraph: "United for Peace",
    image: img46,
  },
  {
    id: 47,
    heading: "09 September 2009",
    year: "2009",
    paragraph:
      "60th Anniversary of Diplomatic Relations between Pakistan and the Philippines in 2009",
    image: img47,
  },
  {
    id: 48,
    heading: "01 October 2009",
    year: "2009",
    paragraph: "60th Anniversary of The People's Republic of China",
    image: img48,
  },
  {
    id: 49,
    heading: "10 October 2009",
    year: "2009",
    paragraph: "Polio Free Pakistan Mother's Vision-Daughter's Mission",
    image: img49,
  },
];
// ----------------------------------------------------------
//                          2010
// ----------------------------------------------------------

export const Buttonf = [
  {
    id: 50,
    heading: "11 January 2010",
    year: "2010",
    paragraph: "ON AAGHAZ-E-HAQOOQ-E-BALOCHISTAN Commemorative Postage Stamp",
    image: img51,
  },
  {
    id: 51,
    heading: "13 February 2010",
    year: "2010",
    paragraph:
      "Golden Jublee Meet Pakistan Navy Rifle Association Commemorative Postage Stamp",
    image: img52,
  },
  {
    id: 52,
    heading: "22 February 2010",
    year: "2010",
    paragraph: "Conferment of Hilal-i-Eissar on Different Cities (NOWSHERA)",
    image: img53,
  },
  {
    id: 53,
    heading: "22 February 2010",
    year: "2010",
    paragraph: "Conferment of Hilal-i-Eissar on Different Cities (PESHAWAR)",
    image: img54,
  },
  {
    id: 54,
    heading: "22 February 2010",
    year: "2010",
    paragraph: "Conferment of Hilal-i-Eissar on Different Cities (SWABI)",
    image: img55,
  },
  {
    id: 55,
    heading: "22 February 2010",
    year: "2010",
    paragraph: "Conferment of Hilal-i-Eissar on Different Cities (MARDAN)",
    image: img56,
  },
  {
    id: 56,
    heading: "22 February 2010",
    year: "2010",
    paragraph: "Conferment of Hilal-i-Eissar on Different Cities (CHARSADDA)",
    image: img57,
  },
  {
    id: 57,
    heading: "07 April 2010",
    year: "2010",
    paragraph:
      "150th Anniversary of the Overseas Investors Chamber of Commerce & Industry (OICCI)",
    image: img58,
  },
  {
    id: 58,
    heading: "14 August 2010",
    year: "2010",
    paragraph: "The 1st Youth Olympic Games, Singapore 2010",
    image: img59,
  },
  {
    id: 59,
    heading: "07 October 2010",
    year: "2010",
    paragraph:
      "On the EVE of 150th Founder's Day Celebration of Lawrence College Ghora Gali Murree",
    image: img61,
  },
  {
    id: 60,
    heading: "05 November 2010",
    year: "2010",
    paragraph:
      "Child Art Series) National Philatelic Exhibition, Pakistan Special Postage Stamp",
    image: img50,
  },
  {
    id: 61,
    heading: "31 December 2010",
    year: "2010",
    paragraph: "Golden Jubilee of Capital City, (1960-2010)",
    image: img60,
  },
  {
    id: 62,
    heading: "15 December 2010",
    year: "2010",
    paragraph: "Silver Jubilee of International Islamic University, Islamabad",
    image: img62,
  },
];

// ----------------------------------------------------------
// 2011
// -------

export const Buttong = [
  {
    id: 63,
    heading: "19 January 2011",
    year: "2011",
    paragraph:
      "100 MILLION CELLULAR SUBSCRIBERS CELEBRATIONS PTA, Headquarter Islamabad Commemorative Postage Stamp",
    image: img63,
  },
  {
    id: 64,
    heading: "10 February 2011",
    year: "2011",
    paragraph:
      "6thPopulation and Housing Census-2011 Commemorative Postage Stamp",
    image: img64,
  },
  {
    id: 65,
    heading: "13 May 2011",
    year: "2011",
    paragraph:
      "150th Anniversary of Pakistan Railways Commemorative Postage Stamp",
    image: img65,
  },
  {
    id: 650,
    heading: "13 December 2011",
    year: "2011",
    paragraph:
      "60th Anniversary of Diplomatic Relations Between Pakistan and Thailand",
    image: img66,
  },
  {
    id: 651,
    heading: "16 September 2011",
    year: "2011",
    paragraph: "Space and Upper Atmosphere Research Commission (SUPARCO)",
    image: img67,
  },
  {
    id: 652,
    heading: "13 May 201121 May 2011",
    year: "2011",
    paragraph:
      "60th Anniversary of Diplomatic Relations Between Pakistan and China",
    image: img68,
  },
  {
    id: 653,
    heading: "23 September 2011",
    year: "2011",
    paragraph:
      "On the Eve of 125th Founder's Day Celebration of Karachi Gymkhana",
    image: img70,
  },
  {
    id: 654,
    heading: "31 December 2011",
    year: "2011",
    paragraph: "150th Anniversary of St. Patrick's High School, Karachi",
    image: img73,
  },
  {
    id: 66,
    heading: "21 May 2011",
    year: "2011",
    paragraph:
      "60th Anniversary of Diplomatic Relations Between Pakistan and China",
    image: img69,
  },
  {
    id: 67,
    heading: "08 June 2011",
    year: "2011",
    paragraph: "HIV Awareness Campaign",
    image: img76,
  },

  {
    id: 68,
    heading: "10 June 2011",
    year: "2011",
    paragraph: "PAKISTAN-RUSSIA FRIENDSHIP",
    image: img78,
  },
  {
    id: 69,
    heading: "24 June 2011",
    year: "2011",
    paragraph: "Child Art Competition National Stamp Exhibition Kurrachee",
    image: img74,
  },
  {
    id: 70,
    heading: "01 July 2011",
    year: "2011",
    paragraph:
      "Golden Jubilee of the Institute of Chartered Accountants of Pakistan (ICAP)",
    image: img77,
  },
  {
    id: 71,
    heading: "17 July 2011",
    year: "2011",
    paragraph:
      "100th Birth Anniversary Celebration 2011 of His Holiness Dr. Syeda Mohammad Burhanuddin Saheb (TUS)",
    image: img79,
  },
  {
    id: 72,
    heading: "14 August 2011",
    year: "2011",
    paragraph: "Golden Jubilee of Zarai Tarqiati Bank Limited",
    image: img80,
  },
  {
    id: 73,
    heading: "18 August 2011",
    year: "2011",
    paragraph: "60th Anniversary in Managing Frequency Spectrum",
    image: img75,
  },
  {
    id: 74,
    heading: "29 August 2011",
    year: "2011",
    paragraph:
      "Joint Commemorative Postage Stamp Between Pakistan and Iran on Minar-e-Pakistan and Milad Tower Iran",
    image: img71,
  },
  {
    id: 77,
    heading: "30 November 2011",
    year: "2011",
    paragraph: "Breast Cancer Awareness Campaign in Pakistan",
    image: img72,
  },

  {
    id: 78,
    heading: "13 December 2011",
    year: "2011",
    paragraph:
      "60th Anniversary of Diplomatic Relations Between Pakistan and Thailand",
    image: img78,
  },
  {
    id: 79,
    heading: "31 December 2011",
    year: "2011",
    paragraph: "150th Anniversary of St. Patrick's High School, Karachi",
    image: img79,
  },
];

// ----------------------------------------------------------
//                          2012
// ----------------------------------------------------------

export const Buttonh = [
  {
    id: 80,
    heading: "18 January 2012",
    year: "2012",
    paragraph:
      "On the Eve of the 100th Meeting of the Federal Cabinet Commemorative Postage Stamp",
    image: img95p,
  },
  {
    id: 81,
    heading: "02 February 2012",
    year: "2012",
    paragraph:
      "Arfa Karim(1995-2012) The World's Youngest Microsoft Certified Professional Commemorative Postage Stamp",
    image: img93p,
  },
  {
    id: 82,
    heading: "22 February 2012",
    year: "2012",
    paragraph:
      "Birthday Celebrations of Air Marshal Nur Khan Commemorative Postage Stamp",
    image: img102p,
  },

  {
    id: 83,
    heading: "24 February 2012",
    year: "2012",
    paragraph: "Gems and Minerals of Pakistan",
    image: img96p,
  },
  {
    id: 84,
    heading: "03 March 2012",
    year: "2012",
    paragraph:
      "125th Anniversary Celebrations of Aitchison College, Lahore 2012",
    image: img91p,
  },

  {
    id: 85,
    heading: "19 March 2012",
    year: "2012",
    paragraph: "150th Years Anniversary of ST.Joseph's Convent School, Karachi",
    image: img88p,
  },
  {
    id: 87,
    heading: "01 April 2012",
    year: "2012",
    paragraph: "50th Anniversary of Asian-Pacific Postal Union",
    image: img83p,
  },
  {
    id: 88,
    heading: "30 April 2012",
    year: "2012",
    paragraph:
      "CELEBRATION YAUM-E-SHUHADA AS THE HONOUR OF THE SUPREME SACRIFICES OF MARTYRS FOR THE SOVEREIGNTY OF PAKISTAN",
    image: img106p,
  },
  {
    id: 89,
    heading: "08 May 2012",
    year: "2012",
    paragraph: "ON PREVENTION OF THALASSEMIA MAJOR IN PAKISTAN",
    image: img103p,
  },
  {
    id: 90,
    heading: "05 May 2012",
    year: "2012",
    paragraph:
      "50th Anniversary of State visit of their Majesties King Bhumibol Adulyadej and Queen Sirikit of Thailand to Pakistan (1962-2012)",
    image: img85p,
  },
  {
    id: 91,
    heading: "05 June 2012",
    year: "2012",
    paragraph: "40th Anniversary of United Nations Environment Programme",
    image: img105p,
  },
  {
    id: 92,
    heading: "15 June 2012",
    year: "2012",
    paragraph: "Golden Jubilee of Ayub Bridge",
    image: img90p,
  },
  {
    id: 93,
    heading: "22 June 2012",
    year: "2012",
    paragraph:
      'Child Art Competition At National Stamp Exhibition "Kurrachee 2012"',
    image: img89s,
  },

  {
    id: 94,
    heading: "28 August 2012",
    year: "2012",
    paragraph: "150th Anniversary of King Edward Medical University, Lahore",
    image: img98p,
  },
  {
    id: 95,
    heading: "30 August 2012",
    year: "2012",
    paragraph: "65 Years of Independence Pakistan",
    image: img82pp,
  },

  {
    id: 96,
    heading: "26 September 2012",
    year: "2012",
    paragraph: "30th Years of Sialkot Chamber of Commerce and Industry",
    image: img104pp,
  },
  {
    id: 97,
    heading: "27 September 2012",
    year: "2012",
    paragraph: "Migratory Birds in Pakistan Wild Life Series",
    image: img99p,
  },

  {
    id: 98,
    heading: "04 October 2012",
    year: "2012",
    paragraph: "Wetlands of Pakistan The Arabian Sea Coral Reefs",
    image: img92p,
  },
  {
    id: 99,
    heading: "19 October 2012",
    year: "2012",
    paragraph: "92nd BIRTH ANNIVERSARY OF HAMEED NASEEM",
    image: img97p,
  },

  {
    id: 100,
    heading: "19 November 2012",
    year: "2012",
    paragraph:
      "Celebration of Diamond Jubilee of Department of Geography University of Karachi",
    image: img94p,
  },
  {
    id: 101,
    heading: "21 November 2012",
    year: "2012",
    paragraph: "50th Anniversary of National Investment Trust Ltd. (NITL)",
    image: img101p,
  },
  {
    id: 341,
    heading: "21 November 2012",
    year: "2012",
    paragraph: "50th Anniversary of National Investment Trust Ltd. (NITL)",
    image: img102p,
  },

  {
    id: 102,
    heading: "25 November 2012",
    year: "2012",
    paragraph: "Muhammad Luthfullah Khan (The Archivist) 1916-2012",
    image: img100p,
  },
  {
    id: 103,
    heading: "15 December 2012",
    year: "2012",
    paragraph: "60 Years of Oxford University Press in Pakistan",
    image: img87p,
  },
  {
    id: 104,
    heading: "24 December 2012",
    year: "2012",
    paragraph:
      "Inauguration of Commercial Operation of First Wind Farm Power Project in Pakistan",
    image: img81s,
  },
];
export const Buttoni = [
  // ----------------------------------------------------------
  //                          2013
  // ----------------------------------------------------------

  {
    id: 105,
    heading: "02 March 2013 ",
    year: "2013",
    paragraph:
      "On the Death Anniversary of Nasir Kazmi Commemorative Postage Stamp",
    image: gmi129,
  },
  // {
  //     id: 106,
  //     heading: '23 March 2013';
  //     year:'2013',
  //     paragraph: 'Qudrat Ullah Shahab (Men of Letters Series) Commemorative Postage Stamp',
  //     image: gmi130,
  // },
  {
    id: 107,
    heading: "23 March 2013",
    year: "2013",
    paragraph:
      "Allama Muhammad Asad (Men of Letters Series) Commemorative Postage Stamp",
    image: gmi131,
  },
  {
    id: 108,
    heading: "11 April 2013",
    year: "2013",
    paragraph: "The Centenary of Kinnaird College for Women (1913-2013)",
    image: gmi132,
  },
  {
    id: 109,
    heading: "21 April 2013",
    year: "2013",
    paragraph: "Allama Muhammad Iqbal (75th Death Anniversary)",
    image: gmi133,
  },
  {
    id: 110,
    heading: "27 April 2013",
    year: "2013",
    paragraph:
      "Sufi Barkat Ali (Men of Letters Series)Commemorative Postage Stamp",
    image: gmi134,
  },
  {
    id: 111,
    heading: "30 April 2013",
    year: "2013",
    paragraph: "On Recipients of Nishan-e-Haider and Hilal-i-Kashmir ",
    image: gmi135,
  },
  {
    id: 112,
    heading: "30 April 2013x",
    year: "2013",
    paragraph: "Inauguration of Pak Army Museum8",
    image: gmi136,
  },
  {
    id: 113,
    heading: "11 May 2013",
    year: "2013",
    paragraph: "General Election-2013",
    image: gmi137,
  },
  {
    id: 114,
    heading: "24 May 2013",
    year: "2013",
    paragraph: "Nawab Sadiq Muhammad Khan Abbasi V",
    image: gmi138,
  },
  {
    id: 115,
    heading: "29 May 2013",
    year: "2013",
    paragraph: " Syed Zamir Jafri, Men of Letters Series",
    image: gmi139,
  },
  {
    id: 116,
    heading: "30 May 2013",
    year: "2013",
    paragraph: " 100 Years of Islamia College Peshawar",
    image: gmi140,
  },
  {
    id: 117,
    heading: "06 June 2013",
    year: "2013",
    paragraph: "Shafiq Ur Rehman",
    image: gmi141,
  },
  {
    id: 118,
    heading: "12 June 2013",
    year: "2013",
    paragraph: " Mumtaz Mufti",
    image: gmi142,
  },
  {
    id: 119,
    heading: "12 June 2013",
    year: "2013",
    paragraph: "Ishfaq Ahmed",
    image: gmi143,
  },
];

// ============================================?
// 2014
//=============================================

export const Buttonj = [
  {
    id: 120,
    heading: "12 March 2014",
    year: "2014",
    paragraph: "Habib Jalib (Men of Letters) Commemorative Postage Stamp",
    image: gmi6a,
  },
  {
    id: 121,
    heading: "20 March 2014",
    year: "2014",
    paragraph:
      "Commemorative Postage Stamp M.M Alam (Men of Letters) Commemorative Postage Stamp",
    image: gmi9a,
  },
  {
    id: 122,
    heading: "06 April 2014",
    year: "2014",
    paragraph:
      "Commemorative Postage Stamp H. M. Habib The Banker Commemorative Postage Stamp",
    image: gmi7a,
  },
  // {
  //     id: 123,
  //     heading: '14 May 2014',
  //     year:'2014',
  //     paragraph: ' Commemorative Postage Stamp Forman Christian College',
  //     image: gmi4a,
  // },
  {
    id: 124,
    heading: "06 April 2014",
    year: "2014",
    paragraph:
      "Commemorative Postage Pakistan of Golden Jubilee-Pakistan Navy Submarian Force ",
    image: gmi5a,
  },
  {
    id: 125,
    heading: "11 July 2014",
    year: "2014",
    paragraph: " Commemorative Postage Stamp 100 Years Frontier Constabulary ",
    image: gmi2a,
  },
  {
    id: 126,
    heading: "05 August 2014",
    year: "2014",
    paragraph:
      " Commemorative Postage Pakistan of 100 Years of Sahiwal Breed Conservation (1914-2014)",
    image: gmi3a,
  },
  {
    id: 127,
    heading: "11 August 2014",
    year: "2014",
    paragraph: "Commemorative Postage Pakistan 2025 One Nation - One Vision",
    image: gmi12a,
  },
  {
    id: 128,
    heading: "December 09,2014",
    year: "2014",
    paragraph:
      ' Say No To Corruption" International Anti Corruption Day Commemorative Postage Pakistan',
    image: gmi8a,
  },
  {
    id: 129,
    heading: "December 04,2014 ",
    year: "2014",
    paragraph:
      "On 100th Birthay Anniversary of Norman E.Borlaug Nobel Peace Prize Laureate Commemorative Postage Pakistan",
    image: gmi11a,
  },
  {
    id: 130,
    heading: "December 29, 2014",
    year: "2014",
    paragraph: "Special Postage Stamps GEMS & MINERALS of Pakistan",
    image: gmi13a,
  },

  {
    id: 131,
    heading: "December 25,2014",
    year: "2014",
    paragraph:
      " Monuments of Ancient Cultures Joint Issue Pakistan-Ukraine Commemorative Postage Stamp & Special Souvenir Sheet",
    image: gmi10a,
  },
  {
    id: 132,
    heading: "December 23,2014",
    year: "2014",
    paragraph: " 14th National Scout Jamboree Commemorative Postage Stamp",
    image: gmi1a,
  },
];

// ============
// 2015
// ============

export const Buttonk = [
  {
    id: 133,
    heading: "04 May 2015",
    year: "2015",
    paragraph: "First 100 MW Solar Plant Commemorative Postage Stamp",
    image: gmi2aa,
  },
  {
    id: 134,
    heading: "14 August 2015",
    year: "2015",
    paragraph: "PAKISTAN CHINA FRIENDLY EXCHANGES Commemorative Postage Stamp",
    image: gmi5aa,
  },
  // {
  //     id: 135,
  //     heading: '07 Sep, 2015,',
  //     year:'2015',
  //     paragraph: 'On The EVE Of Defence Day Golden Jubilee Celebrations Commemorative Postage Stamp',
  //     image: gmi3aa,
  // },
  {
    id: 136,
    heading: "October 12, 2015",
    year: "2015",
    paragraph: "100 Years of Urdu University in Turkey ",
    image: gmi1aa,
  },
  {
    id: 137,
    heading: "",
    year: "2015",
    paragraph: "On Restoration of Murree GPO) Commemorative Postage Stamp",
    image: gmi7aa,
  },
  {
    id: 138,
    heading: "December 16, 2015",
    year: "2015",
    paragraph:
      "On The First Anniversary of The Gruesome Inciden133 of The Army Public School,Peshawar Commemorative Postage Stamp",
    image: gmi4aa,
  },
  {
    id: 139,
    heading: "December 29, 2015",
    year: "2015",
    paragraph: " Murree GPO Commemorative Postage Stamp",
    image: gmi6aa,
  },
];

// ----------------------------------------------------------
// 2016
// ----------------------------------------------------------

export const Buttonl = [
  {
    id: 140,
    heading: "10 Feb, 2016,",
    year: "2016",
    paragraph:
      "On Completion of 50 Years of Safe Operation of 1st NUCLEAR RE-SEARCH REACTOR in Pakistan Commemorative Postage Stamp",
    image: img107,
  },
  {
    id: 141,
    heading: "22 Mar, 2016",
    year: "2016",
    paragraph: "On Water Conservation (WAPDA) Commemorative Postage Stamp",
    image: img117,
  },
  {
    id: 142,
    heading: "14 August, 2016",
    year: "2016",
    paragraph:
      "Philanthropist Abdul Sattar Edhi (1928-2016) Commemorative Postage Stamp",
    image: img108,
  },
  {
    id: 143,
    heading: "22 April, 2016,",
    year: "2016",
    paragraph: "NATIONAL BOOK DAY Commemorative Postage Stamp",
    image: img118,
  },
  {
    id: 144,
    heading: "26 April, 2016,",
    year: "2016",
    paragraph:
      "An Important Personalty In The History Of Pakistan DEWAN BAHADUR S.P. SINGHA Commemorative Postage Stamp",
    image: img201,
  },
  {
    id: 145,
    heading: "21 May, 2016",
    year: "2016",
    paragraph:
      "To Mark The Establishment of 65th Anniversary of Diplomatic Relations Between Pakistan And China Commemorative Postage Stamp",
    image: img119,
  },
  {
    id: 146,
    heading: "06 September, 2016",
    year: "2016",
    paragraph:
      "On Centenary of The DGTR House Building (Old Custom House) Karach Commemorative Postage Stamp",
    image: img200,
  },
  {
    id: 147,
    heading: "23 September, 2016,",
    year: "2016",
    paragraph:
      "Platinum Jubilee Habib Bank Limited (1941-2016) Commemorative Postage Stamp September 23, 2016",
    image: img110,
  },
  {
    id: 148,
    heading: "05 October, 2016,",
    year: "2016",
    paragraph:
      "Pakistan and Belarus Joint Issue Commemorative Postage Stamp October 5, 2016",
    image: img109,
  },
  {
    id: 149,
    heading: "18 October, 2016,",
    year: "2016",
    paragraph:
      "50 Years of Establishment Diplomatic Relations Pakistan and Singapore Joint Issue Commemorative Postage Stamps October 18, 2016",
    image: img111,
  },
  {
    id: 150,
    heading: "20 November, 2016,",
    year: "2016",
    paragraph:
      "100 Years Celebration Of The Rotary Foundation Commemorative Postage Stamp November 20, 2016",
    image: img112,
  },
  {
    id: 151,
    heading: "26 November, 2016,",
    year: "2016",
    paragraph:
      "Sesquicentennial Celebrations Lahore High Court Commemorative Postage Stamp November-26-2016",
    image: img116,
  },
  {
    id: 152,
    heading: "7 December, 2016,",
    year: "2016",
    paragraph:
      "Celebrations Of National Voters Day Election Commission Of Pakistan Commemorative Postage Stamp December 7, 2016",
    image: img113,
  },
  {
    id: 153,
    heading: "18 December, 2016,",
    year: "2016",
    paragraph:
      "Dinshaw Byramji Avari Philanthropist (1902-1988) Commemorative Postage Stamp December 18, 2016",
    image: img115,
  },
  {
    id: 154,
    heading: "30 December, 2016,",
    year: "2016",
    paragraph:
      "Child Art Competition Stamps National Stamp Exhibition Pakistan 2016 Karachi Special Postage Stamps December 30, 2016",
    image: img114,
  },
];
// ----------------------------------------------------------
// 2017
// ----------------------------------------------------------

export const Buttonm = [
  {
    id: 155,
    heading: "01 January, 2017",
    year: "2017",
    paragraph:
      "International Year of Sustainable Tourism for Development - 2017 Commemorative Postage Stamp",
    image: img202,
  },
  {
    id: 156,
    heading: "06 March, 2017",
    year: "2017",
    paragraph:
      "13th Economic Cooperation Organization (ECO) Summit at Islamabad Commemorative Postage Stamp",
    image: img203,
  },
  {
    id: 157,
    heading: "06 March, 2017",
    year: "2017",
    paragraph:
      "13th Economic Cooperation Organization (ECO) Summit at Islamabad Commemorative Postage Stamp",
    image: img204,
  },
  {
    id: 158,
    heading: "29 June, 2017,",
    year: "2017",
    paragraph:
      "Men of Letters Series MAJEED AMJAD (1914-1974) Commemorative Postage Stamp",
    image: img205,
  },
  {
    id: 159,
    heading: "06 July, 2017,",
    year: "2017",
    paragraph:
      "Pakistan and Asian Development Bank 50 Years of Partnering for Development Commemorative Postage Stamp",
    image: img206,
  },
  {
    id: 160,
    heading: "14 October, 2017",
    year: "2017",
    paragraph:
      "Maulana Mufti Mahmood ( 1919- 1980) Commemorative Postage Stamp",
    image: img207,
  },
  {
    id: 161,
    heading: "17 October, 2017",
    year: "2017",
    paragraph:
      "On the Occasion of 200th Birth Anniversary Sir Syed Ahmed Khan Commemorative Postage Stamp & Souvenir Sheet",
    image: img208,
  },
  {
    id: 162,
    heading: "01 November, 2017",
    year: "2017",
    paragraph:
      "On 125th Anniversary of Government Islamia College Railway Road, Lahore Commemorative Postage Stamp",
    image: img210,
  },
  {
    id: 163,
    heading: "02 November, 2017",
    year: "2017",
    paragraph:
      "The ICC Champions Trophy 2017 Commemorative Postage Stamp & Souvenir Sheet",
    image: img211,
  },
  {
    id: 164,
    heading: "09 November, 2017",
    year: "2017",
    paragraph:
      "70Th Anniversary of Establisment of Diplomatic Relations Between Pakistan and Turkey Souvenir Sheet Commemorative Postage Stamp",
    image: img209,
  },
  {
    id: 165,
    heading: "01 December, 2017",
    year: "2017",
    paragraph:
      "On 75th Anniversary of No. 6 Air Transport Support Squadron Pakistan Air Force Commemorative Postage Stamp",
    image: img213,
  },
  {
    id: 166,
    heading: "03 December, 2017,",
    year: "2017",
    paragraph:
      "Dr. Ruth Katharina Martha Pfau (1929-2017) Commemorative Postage Stamp",
    image: img212,
  },
  {
    id: 167,
    heading: "21 December, 2017",
    year: "2017",
    paragraph:
      "The Aga Khan 1957 Diamond Jubilee 2017 Commemorative Postage Stamps",
    image: img214,
  },
];

// ----------------------------------------------------------
// 2018
// ----------------------------------------------------------

export const ButtonN = [
  {
    id: 168,
    heading: "09 February, 2018",
    year: "2018",
    paragraph: "Green Pakistan Programme Commemorative Postage Stamp",
    image: img227,
  },
  {
    id: 169,
    heading: "09 February, 2018",
    year: "2018",
    paragraph: "Green Pakistan Programme Commemorative Postage Stamp",
    image: img228,
  },
  {
    id: 170,
    heading: "09 February, 2018",
    year: "2018",
    paragraph: "Green Pakistan Programme Commemorative Postage Stamp",
    image: img229,
  },
  {
    id: 171,
    heading: "05 March, 2018,",
    year: "2018",
    paragraph:
      "75 Years of Army Burn Hall College Abbottabad Commemorative Postage Stamp",
    image: img225,
  },
  {
    id: 172,
    heading: "9 June, 2018,",
    year: "2018",
    paragraph:
      "PAKISTAN & AZERBAIJAN JOINT ISSUE Commemorative Postage Stamp and Souvenir Sheet",
    image: img226,
  },
  {
    id: 173,
    heading: "09 June, 2018",
    year: "2018",
    paragraph:
      "18th Meeting Of The Council Of Heads Of State Of Shanghai Cooperation Organization Qingdao Summit, 2018 Commemorative Postage Stamp",
    image: img216,
  },
  {
    id: 174,
    heading: "14 June, 2018",
    year: "2018",
    paragraph:
      "60th Anniversary of Urdu Dictionary Board Commemorative Postage Stamp",
    image: img215,
  },
  {
    id: 175,
    heading: "01 July, 2018",
    year: "2018",
    paragraph:
      "70 Years Of Excellence State Bnk of Pakistan (1948-2018) Commemorative Postage Stamp",
    image: img217,
  },
  {
    id: 176,
    heading: "13 July, 2018",
    year: "2018",
    paragraph:
      "Kashmir Martyrs Day (Atrocities in IOK) Commemorative Postage Stamp",
    image: img219,
  },
  {
    id: 177,
    heading: "24 July, 2018",
    year: "2018",
    paragraph:
      "100 Years Of Mama Parsi Girls Secondary School Karachi ( 1918-2018) Commemorative Postage Stamp",
    image: img218,
  },
  {
    id: 178,
    heading: "24 November 2018",
    year: "2018",
    paragraph:
      "Jamsheed Marker Ex-Amassador Born:- November 24, 1922, Quetta Died:- June 21, 2018, Karachi Stamp",
    image: img220,
  },
  {
    id: 179,
    heading: "27 November, 2018",
    year: "2018",
    paragraph:
      "On The 10th Edition of International Defence Exhibition and Seminar  Ideas 2018 Defence Export Promotion Organization Commemorative Postage Stamp November 27, 2018",
    image: img221,
  },
  {
    id: 180,
    heading: "09 December, 2018",
    year: "2018",
    paragraph:
      "IINTERNATIONAL ANTICORRUPTION DAY, CARRYING MESSAGE UNITED AGAINST CORRUPTION FOR PROSPEROUS PAKISTAN COMMEMORATIVE POSTAGE STAMPS DECEMBER 09, 2018",
    image: img222,
  },
  {
    id: 181,
    heading: "24 December, 2018",
    year: "2018",
    paragraph:
      "Silver Jubilee Ghulam Ishaq Khan, Institute Of Engineering Sciences and Technology (1993-2018),Commemorative Postage Stamps, December 24, 2018',",
    image: img224,
  },
  {
    id: 182,
    heading: "26 December 2018",
    year: "2018",
    paragraph:
      "50 Years Of,Crescent Model Higher Secondary School Lahore (1968-2018) Commemorative Postage Stamps December 26, 2018",
    image: img223,
  },
];

//=================================================
// 2019
//=================================================

export const Buttonn = [
  {
    id: 183,
    heading: " 2019",
    year: "2019",
    paragraph:
      "150th Death Anniversary of Mirza Asadullah Khan Ghalib (Urdu Eminent Poet) Commemorative Postage Stamp",
    image: img1bz,
  },
  {
    id: 184,
    heading: "2019",
    year: "2019",
    paragraph:
      " Pakistan's First Remote Sensing Satellites Commemorative Postage Stamp",
    image: img2bz,
  },
  {
    id: 185,
    heading: " 2019",
    year: "2019",
    paragraph:
      "70th Anniversary Of The Commonwealth Organization (1949-2019) Commemorative Postage Stamp",
    image: img3bz,
  },
  {
    id: 186,
    heading: "2019",
    year: "4 October, 2019",
    paragraph:
      "Commission On Science And Technology For Sustainable Development In The South (Comsats) Commemorative Postage Stamp ",
    image: img4bz,
  },
  // {
  //     id: 187,
  //     heading: '2019',
  //     year:'22 October, 2019',
  //     paragraph: "Japan's International Cooperation Towards Pakistan Commemorative Postage Stamp",
  //     image: img5bz,
  // },
  // {
  //     id: 188,
  //     heading: '2019',
  //     year:'4 November, 2019',
  //     paragraph: '30th Years Of The Convention On The Rights Of The Child (CRC) Commemorative Postage Stamp   ',
  //     image: img6bz,
  // },
  //  {
  //      id: 189,
  //      heading: '2019',
  //      year:'12 November, 2019',
  //      paragraph: ' 550th Birthday Celebrations of Sri Guru Nanak Dev Ji (1469-2019) Commemorative Postage Stamp and Souvenir Sheet         ',
  //     image: img7bz,
  //  },
  //  {
  //     id: 190,
  //     heading: '2019',
  //     year:'30 December, 2019',
  //     paragraph: 'Golden Jubilee Celebrations of OIC (1969-2019) Commemorative Postage Stamp and Souvenir Sheet ',
  //    image: img8bz,
  // },
];
// 2020 mock data is at the end of the code

// ----------------------------------------------------------
//                          2021
// ----------------------------------------------------------

export const Buttonp = [
  {
    id: 191,
    heading: "Stamp: 2021-01",
    year: "2021",
    paragraph:
      "10 Years Of Karnal Sher Khan Cadit College Swabi (2011-2021) Commemorative Postage Stamp",
    image: img92,
  },
  {
    id: 192,
    heading: "Stamp: 2021-02",
    year: "2021",
    paragraph:
      "70th Anniversary of Diplomatic Relations Between Pakistan and China Commemorative Postage Stamp",
    image: img93,
  },
  {
    id: 193,
    heading: "Stamp: 2021-03",
    year: "2021",
    paragraph:
      "World Environment Day Pakistan - 2021 Commemorative Postage Stamp",
    image: img94,
  },
  {
    id: 194,
    heading: "Stamp: 2021-04",
    year: "2021",
    paragraph:
      "100th Anniversary of Insulin Discovery (1921-2021) Commemorative Postage Stamp",
    image: img95,
  },
  {
    id: 195,
    heading: "Stamp: 2021-05",
    year: "2021",
    paragraph:
      'State Bank of Pakistan Museum "A Decade of Serving Heritage" (2011-2021) Commemorative Postage Stamp',
    image: img96,
  },
  {
    id: 196,
    heading: "Stamp: 2021-06",
    year: "2021",
    paragraph:
      "100 Years of Excellence NED University of Engineering & Technology, Karachi (1921-2021) Commemorative Postage Stamp",
    image: img97,
  },
  {
    id: 197,
    heading: "Stamp: 2021-07",
    year: "2021",
    paragraph: "National Newspapers Readership Day Commemorative Postage Stamp",
    image: img98,
  },
  {
    id: 198,
    heading: "Stamp: 2021-08",
    year: "2021",
    paragraph:
      "On The Eve Of Karachi Nuclear Power Plant Inauguration Unit-2 (K-2) Commemorative Postage Stamp",
    image: img100,
  },
  {
    id: 199,
    heading: "Stamp: 2021-09",
    year: "2021",
    paragraph:
      "On Pakistan Telecommunication Authority Commemorative Postage Stamp",
    image: img99,
  },
  {
    id: 200,
    heading: "Stamp: 2021-10",
    year: "2021",
    paragraph:
      "Completion of 100 Years Establishment of University of Engineering and Technology Lahore (1921-2021) Commemorative Postage Stamp",
    image: img101,
  },
  {
    id: 201,
    heading: "Stamp: 2021-11",
    year: "2021",
    paragraph:
      "70 Years of Diplomatic Relations Between Pakistan and Germany (1951-2021) Commemorative Postage Stamp",
    image: img102,
  },
  // {
  //     id: 202,
  //     heading: 'Stamp: 2021-12',
  //     year:'2021',
  //     paragraph: 'Golden Jubilee of Hangor Day Commemorative Postage Stamp',
  //     image: img103,

  // },
  // {
  //     id: 203,
  //     heading: 'Stamp: 2021-13',
  //     year:'2021',
  //     paragraph: 'The 70th Anniversary of Diplomatic Relation Between Pakistan and Thailand Commemorative Postage Stamp',
  //     image: img104,

  // },
];

// ----------------------------------------------------------
//                          2022
// ----------------------------------------------------------

export const Buttonq = [
  {
    id: 204,
    heading: "Stamp: 2022-01",
    year: "2022",
    paragraph:
      "70th Anniversary of the Establishment of Diplomatic Relation Between Pakistan and Japan Commemorative Postage Stamp",
    image: img81,
  },
  {
    id: 204,
    heading: "Stamp: 2022-02",
    year: "2022",
    paragraph:
      "The 70th Anniversary of Diplomatic Relations Between Pakistan and Spain Commemorative Postage Stamp",
    image: img84,
  },
  {
    id: 205,
    heading: "2022",
    year: "23 March 2022",
    paragraph:
      "48th Session of OIC Council of Foreign Ministers Islamabad, 22-23 March 2022 Commemorative Postage Stamp",
    image: img82,
  },
  {
    id: 206,
    heading: "Stamp: 2022-04",
    year: "2022",
    paragraph:
      "100 Glorious Years of Lahore College For Women University Lahore (1922-2022) Commemorative Postage Stamp",
    image: img83,
  },
  {
    id: 207,
    heading: "Stamp: 2022-05",
    year: "2022",
    paragraph:
      "Centennial Celebration of Attock Refinery Limited Commemorative Postage Stamp",
    image: img85,
  },
  {
    id: 208,
    heading: "Stamp: 2022-06",
    year: "2022",
    paragraph:
      "Diamond Jubilee of Pakistan (1947-2022) Commemorative Postage Stamp",
    image: img86,
  },
  {
    id: 209,
    heading: "Stamp: 2022-07",
    year: "2022",
    paragraph:
      "On the 11th Edition of International Defence Exhibition and Seminar - Ideas 2022 Defence Export Promotion Organization Ministry of Defence Production, Government of Pakistan Commemorative Postage Stamp",
    image: img87,
  },
  {
    id: 210,
    heading: "Stamp: 2022-08",
    year: "2022",
    paragraph:
      "On the Occasion of 75th Anniversary of the Founding of the Pakistan Institute of International Affairs Commemorative Postage Stamp",
    image: img88,
  },
  {
    id: 211,
    heading: "Stamp: 2022-09",
    year: "2022",
    paragraph:
      "75 Years Deplomatic Relations Between Pakistan and Australia Commemorative Postage Stamp",
    image: img89,
  },
  {
    id: 212,
    heading: "Stamp: 2022-10",
    year: "2022",
    paragraph:
      "Celebrate 100 Years of IDA Rieu for Service Schools for the Blind & Deaf Children (1922-2022) Commemorative Postage Stamp",
    image: img90,
  },
  {
    id: 213,
    heading: "2022",
    year: "27 December, 2022",
    paragraph:
      "75th Anniversary of Diplomatic Relation Between Pakistan and The United States Commemorative Postage Stamp",
    image: img91,
  },
];

// ---------------------------------------------------
//                     2023
// ---------------------------------------------------

export const Buttonr = [
  {
    id: 214,
    heading: "Stamp: 2023-01",
    year: "2023",
    paragraph:
      "40 Years of Wafaqi Mohtasib (Ombudsman) Islamabad (1983-2023) Commemorative Postage Stamp",
    image: img2023q,
  },
  {
    id: 215,
    heading: "Stamp: 2023-02",
    year: "2023",
    paragraph: "International Women's Day Commemorative Postage Stamp",
    image: img2023r,
  },
  {
    id: 216,
    heading: "Stamp: 2023-03",
    year: "2023",
    paragraph:
      "Golden Jubilee Celebrations of the Senate of Pakistan Commemorative Postage Stamp and Souvenir Sheet",
    image: img2023s,
  },
  {
    id: 217,
    heading: "Stamp: 2023-04",
    year: "2023",
    paragraph:
      "Golden Jubilee Celebrations of the Constitution of the Islamic Republic of Pakistan, 1973 Constitution - Guarantor of Rights Commemorative Postage Stamp",
    image: img2023t,
  },
  {
    id: 218,
    heading: "Stamp: 2023-05",
    year: "2023",
    paragraph:
      "Golden Jubilee Celebrations of National Engineering Services Pakistan (PVT.) Limited (NESPAK 1973-2023) Commemorative Postage Stamp",
    image: img2023u,
  },
  {
    id: 219,
    heading: "Stamp: 2023-06",
    year: "2023",
    paragraph:
      "Golden Jubilee Celebrations of Punjab Medical College Faisalabad (1973-2023) Commemorative Postage Stamp",
    image: img2023v,
  },
  {
    id: 220,
    heading: "Stamp: 2023-07",
    year: "2023",
    paragraph:
      "25 Years of Excellence of Central Depository Company of Pakistan Limited Commemorative Postage Stamp",
    image: img2023w,
  },
  {
    id: 221,
    heading: "Stamp: 2023-08",
    year: "2023",
    paragraph:
      '7th Population & Housing Census "First-Ever Digital Census in Pakistan" Commemorative Postage Stamp',
    image: img2023x,
  },
  {
    id: 222,
    heading: "Stamp: 2023-09",
    year: "2023",
    paragraph:
      "To Celebrate of the Decade of China Pakistan Economic Corridor (CPEC) Commemorative Postage Stamp",
    image: img2023y,
  },
  {
    id: 223,
    heading: "Stamp: 2023-10",
    year: "2023",
    paragraph:
      "Eve of 75th Year of Shahadat Captain Raja Muhammad Sarwar Shaheed (1st Nishan-E-Haider) Commemorative Postage Stamp",
    image: img2023z,
  },
];

// ========****************************************

//                          2020

//*************************************** */ ========

export const Buttono = [
  {
    id: 250,
    heading: "Stamp: 2020-01",
    year: "10 January, 2020",
    paragraph:
      "100th Birthday Of Shaheed Hakim Mohammed Said (1920-2020) Commemorative Postage Stamp",
    image: img1bb,
  },

  {
    id: 251,
    heading: "Stamp: 2020-02",
    year: "05 February, 2020",
    paragraph: "Kashmir Solidarity Day Commemorative Postage Stamp",
    image: img2bb,
  },
  {
    id: 252,
    heading: "Stamp: 2020-03",
    year: "17-18 February, 2020",
    paragraph:
      "High Level International Conference In Islamabad On 17-18 February 2020 40 Years Of Presence Of Afghan Refugees In Pakistan Commemorative Postage Stamp",
    image: img3bb,
  },
  {
    id: 253,
    heading: "Stamp: 2020-04",
    year: "18 February, 2020",
    paragraph: "Mahmud Ali( 1919-2006 ) Commemorative Postage Stamp",
    image: img4bb,
  },
  {
    id: 254,
    heading: "Stamp: 2020-05",
    year: "26 June, 2020 ",
    paragraph:
      'International Day Against Drug Abuse & Illicit Trafficking "Say No To Drugs" Commemorative Postage Stamp',
    image: img5bb,
  },
  {
    id: 255,
    heading: "Stamp: 2020-06",
    year: "11 July, 2020",
    paragraph: "World Population Day 2020 Commemorative Postage Stamp",
    image: img6bb,
  },
  {
    id: 256,
    heading: "Stamp: 2020-6A",
    year: "05 August, 2020",
    paragraph:
      "One Year of Indian Occupied Jammu & Kashmir under Siege Special Postage Stamp August 05 2020 Commemorative Postage Stamp",
    image: img7bb,
  },
  {
    id: 257,
    heading: "Stamp: 2020-07",
    year: "06 August, 2020",
    paragraph:
      "Silver Jubilee of Shaukat Khanum Memorial Cancer Hospital and Research Centre Lahore Commemorative Postage Stamp August-06-2020",
    image: img8bb,
  },
  {
    id: 258,
    heading: "Stamp: 2020-08",
    year: "14 September, 2020",
    paragraph:
      "Services To The Cause Of Creation Of Pakistan Of Miangul Abdul Haq Jahanzeb Former Wali Of Swat State Commemorative Postage Stamp September-14-2020",
    image: img9bb,
  },
  {
    id: 259,
    heading: "Stamp: 2020-09",
    year: "24 October, 2020",
    paragraph:
      "75th Anniversary of United Nations Commemorative Postage Stamp October-24-2020",
    image: img10bb,
  },
  {
    id: 260,
    heading: "Stamp: 2020-10",
    year: "11 November, 2020",
    paragraph:
      "Pink Ribbon Breast Cancer Awareness Special Postage Stamp November 11, 2020",
    image: img11bb,
  },
  {
    id: 261,
    heading: "Stamp: 2020-11",
    year: "25 December, 2020",
    paragraph:
      '"New Political Map Of Pakistan-2020" Special Postage Stamp December 25, 2020',
    image: img12bb,
  },
];
